module.exports = __webpack_public_path__ + "static/media/profile-kristin.082699f7.png";